.headerContainer {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 8px;
  min-height: 40px;
  gap: 4px;
  align-items: flex-end;
}

.chartTypeSelectorStyled {
  height: 40px;
}

.chartPriceStyled {
  flex: 1;
  padding: 0;
  [data-price-display-wrapper] {
    min-height: 48px;
  }
}
